import React, { useEffect, useReducer } from "react";
import { GTMService } from "@di";
import { ReportGAEvents } from "@domains/trackers/gtmService";
import { ReportsGTMConstants } from "@domains/aggregates/Reports/ReportsGAConstants";
import { useEllipseDetection } from "@frameworks/web/utils/useEllipseDetection";
import { escapeRegexStr } from "@frameworks/web/utils/regex";
const ReadMoreText = ({ text, className, searchVal, exchange, maxLength, tabName, subtabName, }) => {
    const [isReadMore, setIsReadMore] = React.useState(true);
    const [, forceUpdate] = useReducer((x) => x + 1, 0);
    let arrowSpan = React.useRef();
    const isEllipseVisible = useEllipseDetection(arrowSpan);
    const [isEllipse, setIsEllipse] = React.useState(isEllipseVisible);
    useEffect(() => {
        setIsEllipse(arrowSpan);
    }, []);
    const toggleReadMore = (e) => {
        forceUpdate();
        e.stopPropagation();
        setIsReadMore(!isReadMore);
        isReadMore
            ? GTMService.gtmService(new ReportGAEvents(`${text}`, `${ReportsGTMConstants.NewReports} ${tabName ? " | " + tabName : " "} ${subtabName ? " | " + subtabName : ""}`, `${text}`))
            : null;
    };
    const isSearchMatch = (textVal) => {
        if (searchVal && textVal !== null) {
            if (searchVal.includes("\\"))
                searchVal = searchVal.replace(/\\/g, "");
            searchVal = escapeRegexStr(searchVal);
            const parts = textVal.split(new RegExp(`(${searchVal})`, "gi"));
            if (parts !== null)
                return (React.createElement("span", null, parts.map((part, i) => (React.createElement("span", { key: i, style: part.toLowerCase() === searchVal.toLowerCase()
                        ? { background: "#F0F9FF" }
                        : {} }, part)))));
            else
                return textVal;
        }
        else
            return textVal;
    };
    return (React.createElement("span", { className: `name ${className}` },
        React.createElement("span", { ref: arrowSpan, className: `name-readmore ${isReadMore ? "readmore-ellip" : ""}` },
            isReadMore && text != null
                ? isSearchMatch(text === null || text === void 0 ? void 0 : text.trim().toUpperCase())
                : isSearchMatch(text.toUpperCase()),
            exchange && (React.createElement("span", { className: "tag exchange" },
                exchange,
                " ",
                React.createElement("br", null)))),
        (text === null || text === void 0 ? void 0 : text.length) >= maxLength && isEllipse && (React.createElement("span", { onClick: toggleReadMore }, isReadMore ? (React.createElement("span", { className: "readmore" },
            React.createElement("i", { className: "edel-icon-double-arrow-right" }))) : (React.createElement("span", { className: "readmore" },
            React.createElement("i", { className: "edel-icon-double-arrow-left" })))))));
};
export default ReadMoreText;
